import { makeAutoObservable } from 'mobx';
import { ApiClient, IReleaseParams, ISalaryPeriodResponseItem } from '@Models';

export class ReopenDialogStore {
    private _apiClient = new ApiClient();
    public period: ISalaryPeriodResponseItem | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    public setPeriod = (period: ISalaryPeriodResponseItem | null) => {
        this.period = period;
    };

    public async reopenSelectedPeriod() {
        let params: IReleaseParams =
        {
            periodId: this.period?.id ?? 0
        };
        await this._apiClient.dutyPeriodByPeriodIdReopenPut(params);
    }
}
